import { ICON_COLOR } from '@zep-us/zus/tokens';
import { UploadIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';

/**
 * 파일을 composer 입력 영역 위로 드래그할 때 표시되는 dimmed drop 오버레이.
 * 시안: Figma `File Upload Dimmed` (39095:110549) — violet 8% 배경 + backdrop-blur,
 * 보라 점선 테두리, 가운데 업로드 아이콘(보라 40% 원형) + 안내 문구.
 * 입력 영역 위에 `absolute inset-0`으로 얹어 사용한다.
 */
export const AiBuilderFileDropOverlay = () => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex size-full flex-col items-center justify-center gap-md overflow-clip rounded-md border-2 border-dashed border-strong bg-opacity-violet-2 py-4xl backdrop-blur-[4px]" data-sentry-component="AiBuilderFileDropOverlay" data-sentry-source-file="AiBuilderFileDropOverlay.tsx">
      <div className="flex items-center justify-center rounded-full bg-opacity-violet-5 p-md">
        <UploadIcon size="xl" className="size-8" fill={ICON_COLOR.inverse} data-sentry-element="UploadIcon" data-sentry-source-file="AiBuilderFileDropOverlay.tsx" />
      </div>
      <p className="text-heading-sm-bold text-alternative">
        {t('build:aiBuilderChat.composer.dropFileOverlay')}
      </p>
    </div>;
};